/**
 * Tags raw CSS string so it can be optimized when bundling.
 *
 * Typically used for global CSS injection since we can't use css`..global..`.
 */
export function globalCss(strings: TemplateStringsArray, ...values: unknown[]): string {
  return String.raw({ raw: strings }, ...values);
}
